import { consoleErrorUnlessFiltered } from '../../util/sentryFilters';

/**
 * Automatic banner preparation for render-time / constructor callers.
 * Delegates cache, live-request sharing, orphaned LOADING recovery, and
 * terminal ERROR handling to AdStore.loadAds.
 *
 * @param {Object} props
 * @param {Object} props.adStore
 * @param {Object} props.searchParameters
 * @param {String} [props.path]
 * @param {Boolean} [props.enabled]
 * @returns {Promise|undefined}
 */
const prepareBanner = ({
  adStore,
  searchParameters,
  path = '',
  enabled = true,
}) => {
  if (!enabled || !searchParameters) {
    return;
  }

  return adStore.loadAds(searchParameters, path).catch((e) => {
    consoleErrorUnlessFiltered(e);
  });
};

export default prepareBanner;
